import { ComponentType, useMemo } from 'react';

import Input from '@/components/Input';
import Table from '@/common/Table';
import { TableCellProps } from '@/common/Table/TableCell';
import { getClasses } from '@/utils';

export type EditableCellProps = Omit<TableCellProps, 'children' | 'onChange'> & {
  value?: any;
  onChange?: (value: any) => void;
  as?: ComponentType<any>;
  disabled?: boolean;
};

const EditableCell = ({ className, value, onChange, as = Input, disabled, ...props }: EditableCellProps): JSX.Element => {
  const classes = getClasses('EditableCell', className);
  const isDisabled = disabled !== undefined && disabled !== false;

  const Component = useMemo((): ComponentType<any> => as, [as]);

  return (
    <Table.Cell {...props} className={classes}>
      {isDisabled ? <>{value}</> : <Component value={value} onChange={onChange} />}
    </Table.Cell>
  );
};

export default EditableCell;
